import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FilterTextsPipe } from '../../pipes/filterTexts/filterTexts.pipe';
import { EEntityType, ERelationType } from '@web/dtos';
import { WebTextStore } from '../../services/api/text/web-text-store.service';
import { LanguagePipe } from '../../pipes/language/language.pipe';

@Component({
  selector: 'aw-cms-access-denied-page',
  imports: [CommonModule, RouterLink, FilterTextsPipe, LanguagePipe],
  templateUrl: './cms-access-denied-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CmsAccessDeniedPageComponent {
  protected readonly textStore: WebTextStore = inject(WebTextStore);
  protected readonly ERelationType: typeof ERelationType = ERelationType;
  protected readonly EEntityType: typeof EEntityType = EEntityType;
}
